export const SortChart = [
    {
        group_id: 'WFYOUGL1',
        order: ['WAU', 'WAD', 'RA']
    }
]